export const filterSearchParams = (searchParams, keyValuePairsToRemove = []) => {
  const paramsToRemove = [];
  for (const [key, value] of searchParams) {
    const removeKey =
      value === '' || keyValuePairsToRemove.some((pair) => pair.key === key && (!pair.value || pair.value === value));
    if (removeKey) paramsToRemove.push(key);
  }
  paramsToRemove.forEach((key) => searchParams.delete(key));

  const availabilityFilter = 'filter.v.availability';

  const visibleFilters = [...searchParams.keys()].filter(
    (key) => key !== availabilityFilter && key.includes('filter.')
  );

  // Ensures only available products show when filters are applied.
  if (visibleFilters.length) {
    if (!searchParams.has(availabilityFilter)) {
      searchParams.append(availabilityFilter, 1);
    }
  } else {
    searchParams.delete(availabilityFilter);
  }

  return searchParams.toString();
};
